// @flow

import React, { Component } from 'react';
import _ from 'lodash';
import axios from 'axios';
import clientConf from 'client/conf';
import Translate from 'client/components/translate';
import InputGroup from 'client/components/form/inputGroup';
import type { TranslateType } from 'types/translateType.flow';

type Props = {
  label: TranslateType,
  className: string,
  buttonClassName: string,
  buttonStyle: Object,
  buttonLabel: TranslateType | null,
  buttonContents: *,
  initialValue: string,
  id: string,
  redirect: string,
};

type DrugType = {
  id: number,
  product: string,
  doseForm: string,
};

type State = {
  value: string,
  error: boolean,
  isSelected: boolean,
  selectedDrug: DrugType,
  drugSearchResults: Array<DrugType>,
};

const DRUG_SEARCH_URL = `${clientConf.MARKETPLACE_BASE_URL}/v1/drug`;
const DRUG_PICK_REDIRECT_URL = '/drug/pick/search';

export default class InputDrug extends Component<Props, State> {
  static defaultProps = {
    id: 'drug-input',
    label: { path: 'common.label.drug' },
    className: '',
    buttonClassName: '',
    buttonStyle: {},
    buttonLabel: null,
    buttonContents: null,
    initialValue: '',
    redirect: '',
  };

  state = {
    value: this.props.initialValue,
    error: false,
    isSelected: false,
    selectedDrug: {},
    drugSearchResults: [],
  };

  // calling drug search for list of results
  handleChange = async (event: SyntheticEvent<>) => {
    const value = _.get(event, 'target.value');
    this.setState({
      isSelected: false,
      error: false,
      drugSearchResults: [],
      value,
    });

    if (value && value.length < 3) {
      this.setState({ drugSearchResults: [] });
    } else if (value.length > 2) {
      let options = [];
      const url = `${DRUG_SEARCH_URL}?nameLike=${value}`;

      try {
        const responses = await axios(url);
        options = _.get(responses, 'data', []);
        this.setState({
          drugSearchResults: options,
          error: _.isEmpty(options),
        });
      } catch (err) {
        this.setState({ error: true });
      }
    }
  };

  handleDrugSelect = (drug: DrugType) => {
    this.setState({
      value: drug.product,
      isSelected: true,
      selectedDrug: drug,
    });
  };

  handleSubmit = (event: SyntheticEvent<>) => {
    event.preventDefault();
    const { product, id } = this.state.selectedDrug;
    const { redirect } = this.props;
    window.location.href = redirect
      ? `${redirect}${encodeURIComponent(`${DRUG_PICK_REDIRECT_URL}?name=${product}&id=${id}`)}`
      : `${DRUG_PICK_REDIRECT_URL}?name=${product}&id=${id}`;
  };

  render() {
    const { drugSearchResults, isSelected, error } = this.state;
    const {
      id,
      label,
      className,
      buttonStyle,
      buttonClassName,
      buttonLabel,
      buttonContents,
    } = this.props;

    return (
      <div className="drug-search-container">
        <form onSubmit={this.handleSubmit} autoComplete="off">
          <InputGroup
            id={id}
            label={label}
            value={this.state.value}
            containerClassName={className}
            onChange={this.handleChange}
            error={error}
            type="text">
            <button
              disabled={error}
              style={buttonStyle}
              className={buttonClassName}
              onClick={this.handleSubmit}>
              {buttonLabel && <Translate {...buttonLabel} />}
              {buttonContents}
            </button>
          </InputGroup>
          {(!_.isEmpty(drugSearchResults) || this.state.error) && !isSelected && (
            <ul className="option-container">
              {drugSearchResults.map(drug => (
                <button
                  className="product-name"
                  key={`${drug.id}-${drug.product}`}
                  onClick={() => this.handleDrugSelect(drug)}>
                  {drug.product}
                  <p className="dose mini">{drug.doseForm}</p>
                </button>
              ))}
              {error && (
                <div className="empty-search-message">
                  <Translate path="common.error.invalidDrugSearch" />
                </div>
              )}
            </ul>
          )}
        </form>
      </div>
    );
  }
}
